import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {FlowRessourceObject} from "@app/netscope/model/data-models";
import {FlowViewHost} from "@app/netscope/netscope-common-flowview/flowview-host";

@Component({
  selector: 'app-apps-group-member-element',
  imports: [],
  templateUrl: './apps-group-member-element.component.html',
  styleUrl: './apps-group-member-element.component.css'
})
export class AppsGroupMemberElementComponent {
    @Input() appGroup: FlowRessourceObject;
    @Input() flowComponent: FlowViewHost;

    @Output() descriptionChanged = new EventEmitter<string>();

    // @HostBinding('class')
    // get hostClass(): string {
    //     return `element-container type-${this.type}`;
    // }

    // The name split after each of its separators, a line being allowed to break between two parts
    nameParts(): string[] {
        return (this.appGroup?.name ?? "").split(/(?<=[_\-.:])/);
    }

    onDescriptionChange(value: string): void {
        this.descriptionChanged.emit(value);
    }
}
